import COMMON_LABELS from "../../../../common/locale/ko_KR";

export const LABELS: Record<string, string> = {
    ...COMMON_LABELS,
};

export default LABELS;
